import { useState } from 'react';
import { FarmStatusClient, FarmStatusDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useFarmStatusApi = () => {
    const apiClient = new FarmStatusClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: FarmStatusDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createFarmStatus(data);
        } catch (err: any) {
            setError(err.message || 'Error creating FarmStatus');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: FarmStatusDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateFarmStatus(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating FarmStatus');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getFarmStatusById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching FarmStatus');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchFarmStatuses(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching FarmStatuses');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteFarmStatus(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting FarmStatus');
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, isLoading, error };
};